import { generatePath, matchPath, useLocation } from "react-router";

export const useModalRouteGateParentPath = (parentRoute: string) => {
  const { pathname } = useLocation();

  const match = matchPath({ path: parentRoute, end: false }, pathname); // prefix match
  const params = { context: match?.params.context };
  const parentPath = generatePath(parentRoute, params);

  return parentPath;
};
